import React from 'react'
import Navbar from './Navbar'
export default function About() {
  return (
    <>
      <Navbar />
      <div className="wrapper">
        <div class="col-md-10 my-full-width">
          <p className="i_am_abt" style={{ fontFamily: "Hurricane, cursive" }}>
            <h1 style={{fontFamily: "italic"}}> <b>i-notes</b> </h1>
            i-notes is specially designed for the Computer Science students to help with their notes. No more required to ping up the seniors for notes.
            It consists of the subjects from first to final year. It also comprises of the previous year question papers which will help the students to
            get a better understanding of their examination pattern. It provides you a platform to upload  your notes.
            Upload your notes and get your name mentioned in the Contributors List.  <br />
            HELP OTHERS and SPREAD POSITIVITY ✨!!!

            <br />with Regards ~ <b>IMRAAN</b>
          </p>
        </div>

      </div>




    </>
  )
}
